import moment from "moment-timezone";

export const transformDateToUTC = (date: Date): Date => {
  return moment(date).toDate();
};
